export const OBJECT_TYPE = Object.freeze({
    FORECASTS: "FORECASTS",
    USERS: "USERS",
    ZONES: "ZONES",
    ZONE_GROUPS: "ZONE_GROUPS",
    PERIOD_HAS_ZONES: "PERIOD_HAS_ZONES"
});

export const SHORT_DESCRIPTION = Object.freeze({
    // FORECAST
    ADD_ITEM: "Item added to forecast",
    ADD_ITEMS: "Items added to forecast",
    REMOVE_ITEM: "Item removed from forecast",
    FORECAST_CREATED: "Forecast created",
    FORECAST_DUPLICATED: "Forecast duplicated",
    FORECAST_UPDATED: "Forecast updated",
    FORECAST_SECONDARY_WINDOWS_UPDATED: "Forecast secondary windows (re)published",
    FORECAST_REMOVED: "Forecast removed",
    FORECAST_PUBLISHED: "Forecast published",

    // USER
    USER_CREATED: "User created",
    USER_ADDED: "This user has now access to {brand}",
    USER_UPDATED: "User profile updated",
    USER_ENABLED: "User access reactivated",
    USER_DISABLED: "User access deactivated",
    USER_DELETED: "Access to {brand} has been removed",
    USER_CONNECTED: "Connected successfully on the platform",
    USER_UNBLOCKED: "User unblocked",
    USER_BLOCKED: "User blocked",
    USER_GOD_MODE: "GOD mode activated",

    // ZONE
    ZONE_CREATED: "Zone created",
    ZONE_ADDED: "Zone added to ",
    ZONE_UPDATED: "Zone updated",
    ZONE_TYPE_UPDATED: "Zone type updated",
    ZONE_COPIED: "Zone copied",
    ZONE_DISABLED: "Zone disabled",
    BRAND_ZONE_DELETED: "Zone deleted from ",

    // ZONE GROUP
    ZONE_GROUP_CREATED: "Zone group created",
    ZONE_GROUP_DELETED: "Zone group delete"
});

export const EVENT_TYPE = Object.freeze({
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    GOD_MODE: "GOD_MODE"
});



// WEBPACK FOOTER //
// ./src/components/history/constants.js